import React, { FC } from 'react'

import { Modal } from '@wmgtech/legato'
import { ConditionRender } from 'components'
import { useMatchNotifications } from 'modulesCommon/Notifications/services'
import { ProductMatchModal } from 'modulesCommon/Notifications/components'

const ProductMatchNotificationsModal: FC = () => {
  const { matchedProduct, onClearMatchedProduct, onUpdateDvId, onDeleteHandler } = useMatchNotifications()

  return (
    <ConditionRender
      condition={!!matchedProduct}
      component={
        <Modal
          size="md"
          className="product-match-modal"
          isOpen={true}
          onClose={onClearMatchedProduct}
          shouldCloseOnOverlayClick
          title={
            <>
              Product Match for <span>{matchedProduct?.name ?? ''}</span> found in WMG Database
            </>
          }
        >
          <ProductMatchModal
            assignedGridList={matchedProduct?.assignedGridList ?? []}
            onUpdateDvId={onUpdateDvId}
            onDeleteHandler={onDeleteHandler}
            artistProductsResult={matchedProduct?.matches ?? []}
          />
        </Modal>
      }
    />
  )
}

export default ProductMatchNotificationsModal
